import type {
  BetterstartCommandRuntime,
  InitCommandOptions
} from '@cli-types/core-engine/commands.js'
import { DEFAULT_DATABASE_PLAN } from '@cli-constants/commands.js'
import { renderCommandHelpText } from '@core-engine/templates/renderers/commands/command-help.js'
import { Command } from 'commander'

export function createInitCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('init')
    .description('Scaffold Admin into a new or existing Next.js app')
    .argument('[name]', 'Project name (creates new directory if fresh project)')
    .option('--presets <presets>', 'Comma-separated content preset IDs (e.g. blog)')
    .option('--integrations <integrations>', 'Comma-separated integration IDs (e.g. r2,resend)')
    .option('--namespace <name>', 'Generated admin namespace (e.g. admin, dashboard)')
    .option('-y, --yes', 'Skip prompts (defaults to manual database, local storage, and no deploy)')
    .option('--json', 'With --yes, print a machine-readable setup result on stdout', false)
    .option('--skip-migration', 'Skip running drizzle-kit push after scaffolding')
    .option('--skip-admin-creation', 'Skip prompting to create the initial admin user')
    .option('--skip-dev-server-start', 'Skip prompting to start the development server')
    .option(
      '--database-url <url>',
      'PostgreSQL database connection string (postgres:// or postgresql://)'
    )
    .option('--database-provider <provider>', 'Database provider: vercel, railway, or manual')
    .option(
      '--storage-provider <provider>',
      'Storage provider: vercel-blob, railway-bucket, r2, or local'
    )
    .option('--deploy-provider <provider>', 'Deploy provider: vercel, railway, or none')
    .option(
      '--use-existing-resources',
      'Require database/storage credentials from existing project env files; never provision them'
    )
    .option(
      '--database-plan <id>',
      `Neon plan id for a Vercel-provisioned database (default: ${DEFAULT_DATABASE_PLAN})`
    )
    .option('--railway-workspace <id-or-name>', 'Railway workspace for a new project')
    .option('--railway-project <id-or-name>', 'Existing Railway project to intentionally reuse')
    .option('--railway-environment <id-or-name>', 'Railway environment (default: production)')
    .option('--railway-service <id-or-name>', 'Railway app service (default: web)')
    .option(
      '--railway-bucket-region <region>',
      'Railway bucket region: sjc, iad, ams, or sin (default: iad)'
    )
    .option('--force', 'Overwrite all existing Admin files (nuclear option)')
    .addHelpText('after', renderCommandHelpText('init'))
    .action((name: string | undefined, options: InitCommandOptions) =>
      runtime.runInit(name, options)
    )
}
